<script lang="ts">
  import BooleanCheckbox from "@components/ui/BooleanCheckbox.svelte"
  import ErrorMessage from "@components/ui/ErrorMessage.svelte"
  import InlineTip from "@components/ui/InlineTip.svelte"
  import SubmitButton from "@components/ui/SubmitButton.svelte"

  import { Cancellation } from "@models/cancellations/Cancellation"
  import { Person, fullName } from "@models/profiles/Person"

  import { ValidationErrors } from "@util/validations"

  export let cancellation: Cancellation
  export let errors: ValidationErrors<Cancellation> = {}
  export let hasPendingPayment: boolean
  export let person: Person
  export let submitted: boolean = false
  export let submitting: boolean = false
</script>

<div>
  {#if hasPendingPayment}
    <InlineTip>
      <h2 class="text-gray-900 text-lg mb-2">Passenger has Pending Payments</h2>
      <p class="max-w-para whitespace-normal">
        This passenger has a payment which is still processing. That payment cannot be refunded electronically, until it
        clears. You may want to wait before cancelling this passenger.
      </p>
    </InlineTip>
    <div class="mb-2" />
  {/if}

  <BooleanCheckbox
    name="confirm"
    label="I understand that cancelling a paying passenger will occur immediately and is irreversible"
    bind:value={cancellation.agreeCancellationIsIrreversible}
  />
  <ErrorMessage when={submitted} error={errors.agreeCancellationIsIrreversible} />

  <div class="inline-block mt-2" data-role="submit">
    <SubmitButton {submitting}>Cancel {fullName(person)}</SubmitButton>
  </div>
</div>
